import {
    Box,
    Divider,
    Flex,
    FormControl,
    FormLabel,
    Image,
    useTheme,
} from '@chakra-ui/react';
import React from 'react';
import { useCurrentColors } from '../../hooks/UseCurrentColors/UseCurrentColors';
import IconButton from '../IconButton/IconButton';
interface CustomeDrawerHeaderProps {
    logoHeader: string;
    header?: string;
    onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

function CustomeDrawerHeader({
    header,
    logoHeader,
    onClick,
}: CustomeDrawerHeaderProps) {
    const currentColors = useCurrentColors();
    const theme = useTheme();
    const logo = theme?.images?.headerLogo;
    return (
        <>
            <Flex
                p="5px"
                justify="space-between">
                <Flex>
                    <Image
                        src={logo}
                        maxWidth="100%"
                        width="auto"
                        height={'30px'}
                    />
                    <Box
                        ml="15px"
                        color={currentColors.brand['10']}
                        fontWeight="bold"
                        fontSize="20px">
                        {logoHeader}
                    </Box>
                </Flex>
                <Flex>
                    <IconButton
                        background="transparent"
                        cursor="pointer"
                        border="none"
                        color={currentColors.brand['500']}
                        _hover={{ backgroundColor: 'transparent' }}
                        width="20px"
                        height="20px"
                        aria-label="remove"
                        icon={'ActClose'}
                        variant="ghost"
                        onClick={onClick}
                    />
                </Flex>
            </Flex>
            <Divider
                borderColor={currentColors.brand['700']}
                width="100%"
                my="10px"
            />
            {header && (
                <FormControl>
                    <FormLabel
                        htmlFor="filters"
                        fontWeight="bold"
                        color={currentColors.brand['10']}
                        fontSize="18px">
                        {header}
                    </FormLabel>
                </FormControl>
            )}
        </>
    );
}
export default CustomeDrawerHeader;
